import htm from "htm";
import { h, hydrate, render, Component, Fragment } from "preact";
import * as hooks from "preact/hooks";

const html = htm.bind(h);

const renderer = {
    preact: {
        html,
        h,
        render,
        hydrate,
        Component,
        Fragment,
        hooks,
    },
};

export default function returnRenderer() {
    return Promise.resolve(renderer);
}
